import { render, staticRenderFns } from "./ImageGrouping.vue?vue&type=template&id=520815d4&scoped=true&"
import script from "./ImageGrouping.vue?vue&type=script&lang=ts&"
export * from "./ImageGrouping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520815d4",
  null
  
)

export default component.exports